export default __webpack_public_path__ + "static/media/runner5.789329d7.jpg";